import transparentLogo from "../images/transparent-logo.png";
import logoWithBackground from "../images/logo-with-background.png"
import logoWithWhiteBorder from "../images/logo-with-white-border.png"

import googlePay from "../images/google-pay.png"
import googlePayTransparent from "../images/google-pay-transparent.png"
import googlePayRounded from '../images/google-pay-rounded.png'
import googlePayDark from '../images/google-pay-dark.png'
import applePay from "../images/apple-pay.png"

import visa from "../images/visa.png"
import mastercard from "../images/mastercard.png"
import amex from "../images/americanExpress.png"
import discover from "../images/discover.png"

export default { 
    transparentLogo, 
    logoWithBackground, 
    logoWithWhiteBorder, 

    googlePay, 
    googlePayTransparent,
    googlePayRounded,
    googlePayDark,
    applePay, 

    visa,
    mastercard,
    amex, 
    discover
};
